define((require) => {
    "use strict";

    const BreakpointGroup                     = require("shared/ui/breakpoint/BreakpointGroup");
    const BreakpointGroupRangeMixinPrototype  = require("shared/ui/breakpoint/BreakpointGroupRangeMixinPrototype");

    /**
     * A <tt>BreakpointGroup</tt> *mixin* that adds breakpoint range functionality to the <tt>BreakpointGroup</tt>.
     *
     * @author Kim Knudsen / <a href="http://www.zmags.com">Zmags</a>
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    return BreakpointGroup.mixin("BreakpointGroupRangeMixin", BreakpointGroupRangeMixinPrototype);
});



// WEBPACK FOOTER //
// ./src/shared/ui/breakpoint/BreakpointGroupRangeMixin.js